import Footer from "./components/FooterActions";
import News from "./components/News";
import Parallax from "./components/ParallaxSection";
import Services from "./components/Services";
import Team from "./components/Team";
import Interest from "./components/interest/Interest";

export const LandingPage = () => {
  return (
    <>
      <Services />
      <Interest />
      <Parallax />
      <Team />
      <News />
      <Footer />
    </>
  );
};
